(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7385],{

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ fromUnixTime; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Number} unixTime - the given Unix timestamp (in seconds)
 * @returns {Date} the date
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */

function fromUnixTime(dirtyUnixTime) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var unixTime = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyUnixTime);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(unixTime * 1000);
}

/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 42886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity",
      function () {
        return __webpack_require__(87986);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57247);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var CardFooter = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5ed8a823-0"
}).withConfig({
    componentId: "sc-cddac6ee-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh);
CardFooter.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardFooter);


/***/ }),

/***/ 87986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ liquidity; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(23774);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardFooter.tsx
var CardFooter = __webpack_require__(95596);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(543);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(8253);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/components/PositionCard/index.tsx
var PositionCard = __webpack_require__(86323);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(84915);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/components/Loader/Dots.tsx
var Dots = __webpack_require__(48468);
// EXTERNAL MODULE: ./src/components/App/index.tsx + 3 modules
var App = __webpack_require__(45460);
// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
;// CONCATENATED MODULE: ./src/views/Pool/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Body = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-fd0184c8-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.dropdownDeep;
});
function Pool() {
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var t = (0,src/* useTranslation */.$G)().t;
    // fetch the user's balances of all tracked V2 LP tokens
    var trackedTokenPairs = (0,user_hooks/* useTrackedTokenPairs */.B3)();
    var tokenPairsWithLiquidityTokens = (0,react.useMemo)(function() {
        return trackedTokenPairs.map(function(tokens) {
            return {
                liquidityToken: (0,user_hooks/* toV2LiquidityToken */.Ce)(tokens),
                tokens: tokens
            };
        });
    }, [
        trackedTokenPairs
    ]);
    var liquidityTokens = (0,react.useMemo)(function() {
        return tokenPairsWithLiquidityTokens.map(function(tpwlt) {
            return tpwlt.liquidityToken;
        });
    }, [
        tokenPairsWithLiquidityTokens
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useTokenBalancesWithLoadingIndicator */.v2)(account !== null && account !== void 0 ? account : undefined, liquidityTokens), 2), v2PairsBalances = ref[0], fetchingV2PairBalances = ref[1];
    // fetch the reserves for all V2 pools in which the user has a balance
    var liquidityTokensWithBalances = (0,react.useMemo)(function() {
        return tokenPairsWithLiquidityTokens.filter(function(param) {
            var liquidityToken = param.liquidityToken;
            var ref;
            return (ref = v2PairsBalances[liquidityToken.address]) === null || ref === void 0 ? void 0 : ref.greaterThan("0");
        });
    }, [
        tokenPairsWithLiquidityTokens,
        v2PairsBalances
    ]);
    var v2Pairs = (0,usePairs/* usePairs */.z$)(liquidityTokensWithBalances.map(function(param) {
        var tokens = param.tokens;
        return tokens;
    }));
    var v2IsLoading = fetchingV2PairBalances || (v2Pairs === null || v2Pairs === void 0 ? void 0 : v2Pairs.length) < liquidityTokensWithBalances.length || (v2Pairs === null || v2Pairs === void 0 ? void 0 : v2Pairs.length) && v2Pairs.every(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), pairState = _param[0];
        return pairState === usePairs/* PairState.LOADING */._G.LOADING;
    });
    var allV2PairsWithLiquidity = v2Pairs === null || v2Pairs === void 0 ? void 0 : v2Pairs.filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), pairState = _param[0], pair = _param[1];
        return pairState === usePairs/* PairState.EXISTS */._G.EXISTS && Boolean(pair);
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), pair = _param[1];
        return pair;
    });
    var renderBody = function() {
        if (!account) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textAlign: "center",
                children: t("Connect to a wallet to view your liquidity.")
            });
        }
        if (v2IsLoading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                    children: t("Loading")
                })
            });
        }
        if ((allV2PairsWithLiquidity === null || allV2PairsWithLiquidity === void 0 ? void 0 : allV2PairsWithLiquidity.length) > 0) {
            return allV2PairsWithLiquidity.map(function(v2Pair, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionCard/* default */.Z, {
                    pair: v2Pair,
                    mb: index < allV2PairsWithLiquidity.length - 1 ? "16px" : 0
                }, v2Pair.liquidityToken.address);
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "textSubtle",
            textAlign: "center",
            children: t("No liquidity found.")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(App/* AppBody */.j, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                    title: t("Your Liquidity"),
                    subtitle: t("Remove liquidity to receive tokens back")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                    children: [
                        renderBody(),
                        account && !v2IsLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            alignItems: "center",
                            mt: "24px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    mb: "8px",
                                    children: t("Don't see a pool you joined?")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/find",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        id: "import-pool-link",
                                        variant: "secondary",
                                        scale: "sm",
                                        as: "a",
                                        children: t("Find other LP tokens")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFooter/* default */.Z, {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/add",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            id: "join-pool-button",
                            width: "100%",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                color: "white"
                            }),
                            children: t("Add Liquidity")
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/liquidity.tsx

/* harmony default export */ var liquidity = (Pool);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7425,3750,561,5652,6323,9774,2888,179], function() { return __webpack_exec__(42886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);